import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { hideMessage } from '~/actions';
import { showErrorMessage } from '~/domain/utils';
import { GetJobPostingInsufficientAccessError } from '../errors';
import { PermanentJobsService } from '../services';

export function useGetJobPostDetail(postId?: string) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const query = useQuery({
    queryKey: ['GET_JOB_POSTING_DETAIL', postId],
    queryFn: () => PermanentJobsService.getJobPostDetail(postId!),
    enabled: !!postId,
    refetchOnWindowFocus: false,
    retry: false,
  });

  const { data, isError, isLoading, isFetching, error } = query;

  useEffect(() => {
    if (!isError) {
      return;
    }

    showErrorMessage({
      error,
      onRightButtonClick() {
        if (error instanceof GetJobPostingInsufficientAccessError) {
          navigate('/permanent-jobs/postings');
        }
        dispatch(hideMessage());
      },
    });
  }, [dispatch, error, isError, navigate]);

  return {
    ...query,
    data: data?.data,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
  };
}
